import {useEffect, useState} from "react";
import store from 'storejs';
import {getPaymentMethods} from "../Functions/ServerFunctions";
import {ONE_TIME} from "../Constants/PaymentTypes";

export const useFetchMethods = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(!store('?default_country'));
        getPaymentMethods().then(response => {
            store(response.methods);
            store('default_country', response.default_country);
            const event = new Event('storageChange');
            document.dispatchEvent(event);
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            console.log(error)
        });
    }, [])

    return (loading && !store('?'+ONE_TIME));
}
